"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceFailureType = void 0;
exports.InvoiceFailureType = {
    SourcePaymentError: "SOURCE_PAYMENT_ERROR",
    DestinationPaymentError: "DESTINATION_PAYMENT_ERROR",
    RejectedHighRisk: "REJECTED_HIGH_RISK",
    InsufficientFunds: "INSUFFICIENT_FUNDS",
    ProcessingError: "PROCESSING_ERROR",
};
